import React from 'react';
import './Header.css';

const Header = () => {
    return (
        <div>
            <h1 className="header">User Information</h1>
        </div>
    );
};

export default Header;